import Head from "next/head";
import Link from "next/link";
import COMMONCONSTANT from "@constants/commonConstant";

const Terms = () => {
  return (
    <>
      <Head>
        <title>Terms &amp; Conditions | LoneStar CR</title>
        <meta name="description" content="LoneStar CR Terms of Use for ClearK12 services." />
        <meta name="robots" content="noindex, follow" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&family=Poppins:wght@700;800;900&display=swap"
          rel="stylesheet"
        />
        <link href="/static/css/terms.css" rel="stylesheet" key="termscss" />
      </Head>

      <header aria-label="Main navigation" className="nav">
        <Link href="/" aria-label="LoneStar CR home">
          <img alt="LoneStar CR" className="logo" src="/static/imgs/Logo.png" />
        </Link>
        <nav aria-label="Terms page navigation" className="nav-links">
          <Link href="/">Home</Link>
          <Link href="/privacy">Privacy</Link>
          <a className="nav-btn" href={COMMONCONSTANT.ROUTEPATH.LOGINURL}>
            Login
          </a>
        </nav>
      </header>

      <main>
        <section className="legal-hero">
          <span className="eyebrow">LoneStar CR</span>
          <h1>Terms &amp; Conditions</h1>
          <p className="hero-copy">These Terms of Use govern your access to LoneStar CR and related ClearK12 services.</p>
        </section>

        <div className="legal-layout">
          <aside className="legal-aside" aria-label="Terms summary and contact">
            <p className="aside-title">Effective Date</p>
            <p>July 6, 2026</p>
            <div className="contact-card">
              <strong>Questions about these terms?</strong>
              <address>
                ClearK12, Inc.
                <br />
                7800 Dallas Parkway,
                <br />
                Suite 430
                <br />
                Plano, TX 75024
                <br />
                <br />
                <a href="mailto:hi@cleark12.com">hi@cleark12.com</a>
              </address>
            </div>
          </aside>

          <article className="legal-document">
            <p className="effective-date">
              <strong>Effective date:</strong> July 6, 2026
            </p>

            <section className="legal-section">
              <h2>Welcome to LoneStar CR</h2>
              <p>
                Welcome to LoneStar CR, owned and operated by ClearK12, Inc. (&quot;ClearK12&quot;). These Terms of Use
                govern your use of LoneStar CR and any associated websites or services provided by ClearK12
                (collectively, &quot;ClearK12 Services&quot;). By accessing or using LoneStar CR, you agree to comply
                with and be bound by these Terms of Use. If you do not agree with these Terms, please do not use
                LoneStar CR.
              </p>
              <p>
                How we handle information about you depends on which ClearK12 Services you use and how you use them.
                If you have questions, please contact us at <a href="mailto:hi@cleark12.com">hi@cleark12.com</a>.
              </p>
            </section>

            <section className="legal-section">
              <h2>Acceptance of Privacy Policy</h2>
              <p>
                By agreeing to these Terms of Use, you also agree to the terms of ClearK12&apos;s Privacy Policy,
                which is expressly incorporated herein. Please review the Privacy Policy before using LoneStar CR.
                All personal information provided to us as a result of your use of LoneStar CR will be handled in
                accordance with our Privacy Policy. In case of any conflict between these Terms of Use and the
                Privacy Policy, these Terms of Use shall prevail.
              </p>
            </section>

            <section className="legal-section">
              <h2>Consent to Other Agreements</h2>
              <p>
                When you sign up to use a special feature of LoneStar CR, you may be asked to agree to special terms
                governing your use of that feature. Such agreements, known as &quot;click-through&quot; agreements,
                will supplement or amend these Terms of Use only with respect to the matters governed by the
                click-through agreement.
              </p>
            </section>

            <section className="legal-section">
              <h2>Ownership of LoneStar CR and Its Content</h2>
              <p>
                LoneStar CR and its content are protected under applicable intellectual property and other laws. All
                content and intellectual property rights therein are the property of ClearK12 or are included with
                the permission of the rights owner. You do not acquire any ownership rights to any content viewed
                through LoneStar CR. Except as expressly provided herein, none of the content may be used, copied,
                reproduced, distributed, republished, downloaded, modified, displayed, posted, or transmitted in any
                form or by any means without ClearK12&apos;s prior written permission.
              </p>
              <p>
                Permission is granted to lawfully access and use LoneStar CR and to display, download, or print
                portions of LoneStar CR on a temporary basis for personal, educational, noncommercial use only,
                provided that you do not modify the content and retain all copyright and other proprietary notices
                contained in the content.
              </p>
            </section>

            <section className="legal-section">
              <h2>Posting and Sharing Licensed Materials</h2>
              <p>
                Users of LoneStar CR may post or share their own licensed curriculum content on the platform.
                ClearK12 may, upon user request and license verification, assist in adding such content. It is
                strictly prohibited to upload, post, transmit, or otherwise share any content for which you do not
                have proper licensing or rights. ClearK12 will promptly remove any unlicensed materials and may
                terminate the accounts of users who repeatedly infringe upon this policy.
              </p>
            </section>

            <section className="legal-section">
              <h2>Trademarks</h2>
              <p>
                ClearK12&apos;s names and logos, all product and service names, all graphics, button icons, avatars,
                and all trademarks, service marks, and logos appearing on LoneStar CR, unless otherwise noted, are
                trademarks, whether registered or not, of ClearK12 (the &quot;ClearK12 Marks&quot;). You are not
                authorized to display or use the ClearK12 Marks without our prior written permission. The use or
                misuse of the ClearK12 Marks or any third-party trademarks is expressly prohibited.
              </p>
            </section>

            <section className="legal-section">
              <h2>Acceptable Use</h2>
              <p>You may use LoneStar CR only for lawful purposes and in accordance with these Terms of Use. You agree not to use LoneStar CR to:</p>
              <ul>
                <li>
                  Upload, post, transmit, or otherwise make available any content that is harmful, hateful,
                  threatening, abusive, harassing, libelous, defamatory, obscene, vulgar, pornographic, racially
                  disparaging, misleading, fraudulent, or invasive of another&apos;s privacy.
                </li>
                <li>
                  Engage in any activity that is illegal under criminal or civil law or otherwise violates any local,
                  state, national, or international law, rule, or regulation.
                </li>
                <li>Use, create, or share worksheets or any other content that you do not have the proper licensing for.</li>
                <li>
                  Violate or infringe upon the rights of others, including patents, copyrights, trademarks, privacy,
                  publicity, trade secrets, or any other rights.
                </li>
                <li>Request or solicit personal or private information from any individual.</li>
                <li>
                  Contain software viruses or any other computer code, files, or programs designed to interrupt,
                  destroy, or limit the functionality of LoneStar CR or any computer software or hardware.
                </li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>User-Generated Content</h2>
              <p>
                You are responsible for any content you post on or through LoneStar CR. ClearK12 is not liable for
                any user-generated content, including any errors or omissions in such content. You own the copyright
                in any original user-generated content you post, but by using LoneStar CR, you grant ClearK12 a
                nonexclusive, fully paid, worldwide, perpetual, irrevocable, royalty-free, transferable license to
                use, copy, modify, distribute, publicly display and perform, publish, transmit, remove, retain,
                repurpose, and commercialize user-generated content in any and all media or form of communication,
                without compensation to you.
              </p>
              <p>
                ClearK12 has the right to monitor all user-generated content and may remove or block any content at
                any time without notice at its sole discretion.
              </p>
            </section>

            <section className="legal-section">
              <h2>Feedback</h2>
              <p>
                Feedback provided to ClearK12 through LoneStar CR will be and remain ClearK12&apos;s exclusive
                property. By submitting feedback, you assign to ClearK12 all worldwide rights, title, and interests
                in your feedback, including all copyrights and other intellectual property rights.
              </p>
            </section>

            <section className="legal-section">
              <h2>Your Obligations</h2>
              <p>
                You agree to provide accurate, current, and complete personal information and to update it as
                necessary. You are responsible for maintaining the confidentiality of your username and password and
                for all activities that occur under your account. You agree to notify ClearK12 immediately of any
                unauthorized use of your account.
              </p>
            </section>

            <section className="legal-section">
              <h2>Disclaimers</h2>
              <p>
                LoneStar CR and all its content are provided on an &quot;as is,&quot; &quot;as available&quot; basis
                without warranties of any kind. ClearK12 disclaims all warranties, whether express or implied,
                including but not limited to warranties of title, non-infringement, merchantability, and fitness for
                a particular purpose. ClearK12 does not guarantee that LoneStar CR will be secure, error-free, or
                free of harmful components.
              </p>
            </section>

            <section className="legal-section">
              <h2>Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law, ClearK12 and its licensors and service providers are not
                liable for any direct, indirect, incidental, special, or consequential damages arising out of or in
                connection with your use of LoneStar CR.
              </p>
            </section>

            <section className="legal-section">
              <h2>Indemnity</h2>
              <p>
                You agree to indemnify and hold ClearK12 harmless from any loss, liability, claim, or demand,
                including reasonable attorneys&apos; fees, arising out of your use of LoneStar CR in violation of
                these Terms of Use.
              </p>
            </section>

            <section className="legal-section">
              <h2>Modification and Discontinuation</h2>
              <p>ClearK12 reserves the right to modify, edit, delete, suspend, or discontinue LoneStar CR or any part thereof at any time without notice.</p>
            </section>

            <section className="legal-section">
              <h2>Governing Law and Jurisdiction</h2>
              <p>
                These Terms of Use are governed by the laws of the State of Texas. All actions or proceedings arising
                out of or relating to these Terms of Use will be venued exclusively in state or federal court in
                Collin County, Texas.
              </p>
            </section>

            <section className="legal-section">
              <h2>Changes to Terms of Use</h2>
              <p>
                ClearK12 reserves the right to update or modify these Terms of Use at any time without prior notice.
                Your continued use of LoneStar CR after any changes are posted constitutes your acceptance of the
                revised Terms of Use.
              </p>
            </section>

            <section className="legal-section">
              <h2>Entire Agreement</h2>
              <p>
                These Terms of Use, along with our Privacy Policy and any click-through agreements applicable to you,
                constitute the entire agreement between you and ClearK12 regarding your use of LoneStar CR.
              </p>
            </section>

            <div className="thanks">
              <p>
                Thank you for using LoneStar CR. We appreciate you taking the time to read our Terms of Use. Your
                understanding and compliance with these terms help us provide a better experience for all users.
              </p>
            </div>
          </article>
        </div>
      </main>

      <footer aria-label="Footer" className="site-footer">
        <div className="site-footer-inner">
          <div className="footer-brand">
            <img alt="LoneStar CR" className="footer-logo" src="/static/imgs/Logo.png" />
            <div className="footer-copy">&copy; 2026 ClearK12, Inc. All rights reserved.</div>
          </div>
          <nav aria-label="Legal links" className="footer-links">
            <Link href="/terms" aria-current="page">
              Terms &amp; Conditions
            </Link>
            <span aria-hidden="true" className="footer-divider"></span>
            <Link href="/privacy">Privacy Policy</Link>
          </nav>
        </div>
      </footer>
    </>
  );
};

export default Terms;
